import React from 'react';
import { ActionBar } from '@core/ui';
import * as Icons from '@ant-design/icons';

import { HeaderButton, HeadPortal } from '@modules/layout';

import { useBoxesActionBar } from '../hooks';
import { Space } from 'antd';
import { boxTransfersQueryKeys } from '@modules/box-transfers/utils';

export const BoxesActionBar = () => {
  const { selection, state, resetSelection, create, selectAll, reset, fetch, openBoxHistory } = useBoxesActionBar();

  const branchId = state.filters.find((filter) => filter.id === boxTransfersQueryKeys.branch.id)?.value;

  const selectAllButton = (
    <HeaderButton onClick={selectAll} icon={<Icons.CheckCircleOutlined />}>
      Hamısını seç
    </HeaderButton>
  );

  const resetSelectionButton = (
    <HeaderButton onClick={resetSelection} icon={<Icons.CloseCircleOutlined />}>
      {selection.length} sətir seçilib
    </HeaderButton>
  );

  return (
    <HeadPortal>
      <ActionBar $flex={true}>
        <Space size={0}>
          <HeaderButton onClick={create} icon={<Icons.PlusCircleOutlined />}>
            Yeni
          </HeaderButton>
          {!selection.length ? selectAllButton : resetSelectionButton}
          <HeaderButton onClick={fetch} icon={<Icons.ReloadOutlined />}>
            Yenilə
          </HeaderButton>
          <HeaderButton onClick={reset} icon={<Icons.ClearOutlined />}>
            Sıfırla
          </HeaderButton>
        </Space>
        <Space size={0}>
          <HeaderButton disabled={!branchId} onClick={() => openBoxHistory(branchId)} icon={<Icons.HistoryOutlined />}>
            Tarixçə
          </HeaderButton>
        </Space>
      </ActionBar>
    </HeadPortal>
  );
};
